import {Component} from '@angular/core';
import {Storage} from '@ionic/storage-angular';
import {ModalController, Platform} from '@ionic/angular';
import {ActionPerformed, PushNotifications, PushNotificationSchema, Token,} from '@capacitor/push-notifications';
import {StorageService} from './services/storage.service';
import {NotificationService} from './services/notification.service';
import {Device} from '@capacitor/device';
import {App} from '@capacitor/app';
import {BadgeService} from './services/badge.service';
/*import {Badge} from '@awesome-cordova-plugins/badge/ngx';*/
import {StatusBar, Style} from '@capacitor/status-bar';
import {Constant} from './shared/constants/constant.class';
import {Router} from '@angular/router';
import {MsImageViewerService} from './components/ms-image-viewer/ms-image-viewer.service';
import {AuthTokenService} from './services/auth-token.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private storage: Storage,
              private platform: Platform,
              private router: Router,
              private notificationService: NotificationService,
              private localStorage: StorageService,
              private badgeService: BadgeService,
              private modalCtrl: ModalController,
              private imageViewer: MsImageViewerService,
              private authToken: AuthTokenService,
              /*private badge: Badge*/
  ) {
    this.platform.ready().then(() => {
      this.loadConfigFromApi();
      this.watchAppState();
      this.handleHardwareBack();
    });
  }

  /**
   * Nút Back cứng của Android.
   *
   * Ionic đăng ký sẵn một handler ở ưu tiên 100 để Back đóng modal/alert,
   * NHƯNG chỉ đăng ký khi overlay đó có backdropDismiss = true
   * (ionic-team/ionic-framework#24794 — đã xác nhận là bug, chưa sửa).
   *
   * Các modal toàn màn hình của app đặt backdropDismiss = false để chặn lỗi
   * "vuốt một cái là tự đóng hộp thoại". Hệ quả: Back không còn đóng modal,
   * mà rơi xuống router và rời luôn trang — đúng cái cảm giác "văng ra ngoài
   * danh sách" mà ta vừa đi sửa.
   *
   * Thêm nữa, trình xem ảnh ms-image-viewer không phải modal nên Ionic không
   * biết tới nó; Back sẽ đi qua nó mà bỏ lại lớp phủ ảnh trên màn.
   *
   * Vậy nên tự lo, ở ưu tiên 101 (cao hơn Ionic) và xử lý theo thứ tự từ
   * trên xuống dưới:
   *   1. Đang xem ảnh  -> chỉ đóng ảnh
   *   2. Đang mở modal -> đóng modal (kể cả khi backdropDismiss = false)
   *   3. Không có gì   -> nhường lại cho Ionic / router như bình thường
   */
  private handleHardwareBack() {
    if (!this.platform.is('android')) {
      return;   // iOS không có nút Back cứng
    }
    this.platform.backButton.subscribeWithPriority(101, async (processNextHandler) => {
      if (this.imageViewer.isOpen) {
        this.imageViewer.close();
        return;
      }
      const top = await this.modalCtrl.getTop();
      if (top) {
        await top.dismiss();
        return;
      }
      processNextHandler();
    });
  }

  /**
   * Mỗi lần app quay lại foreground thì đồng bộ lại badge với server.
   * Không có bước này thì con số do APNs/FCM đặt sẽ nằm lại vĩnh viễn,
   * vì chỉ chính app mới xoá được badge trên icon.
   */
  private watchAppState() {
    if (!(this.platform.is('ios') || this.platform.is('android'))) {
      return;
    }
    App.addListener('appStateChange', ({isActive}) => {
      if (isActive) {
        this.badgeService.refresh();
      }
    });
    // Chạy luôn một lần lúc mở app
    this.badgeService.refresh();
  }

  loadConfigFromApi() {
    if (this.platform.is('android')) {
      document.body.classList.add('platform-android');
    } else if (this.platform.is('ios')) {
      document.body.classList.add('platform-ios');
    } else {
      document.body.classList.add('platform-desktop');
    }


    this.storage.get(Constant.BOTTOM_OFFSET).then((bottomOffset) => {
      const screenHeight = window.screen.height;
      const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
      const diff = screenHeight - viewportHeight;
      console.log(screenHeight, viewportHeight, window.visualViewport?.height, window.innerHeight);
      if (bottomOffset) {
        document.documentElement.style.setProperty(
          '--safe-bottom-offset',
          bottomOffset + 'px'
        );
      } else {
        // fallback về env
        document.documentElement.style.setProperty(
          '--safe-bottom-offset',
          'env(safe-area-inset-bottom)'
        );
      }
    });
  }

  async ngOnInit() {
    try {
      StatusBar.setStyle({style: Style.Dark});
    } catch (e) {

    }
    const info = await Device.getInfo();
    const deviceId: any = await Device.getId();
    // console.log(info);
    const deviceInfo = {
      name: info.name ? info.name : 'LA',
      platform: info.platform,
      operatingSystem: info.operatingSystem,
      model: info.model,
      // PHẢI là CHUỖI, không phải object.
      //
      // Device.getId() đổi dạng trả về theo bản Capacitor:
      //   Capacitor <= 3 : { uuid: '...' }
      //   Capacitor >= 4 : { identifier: '...' }   <-- bản này (@capacitor/device ^5)
      // Trước đây gán thẳng `uuid: deviceId` nên deviceInfo.uuid là OBJECT, rồi
      // được post lên làm deviceId. Server khai deviceId là string, JSON.NET bỏ
      // tay, Web API đặt input = null và MobileLogin nổ NullReferenceException.
      //
      // Đọc cả hai khoá để không phụ thuộc bản Capacitor, lần sau nâng cấp
      // không vỡ lại.
      uuid: (deviceId && (deviceId.identifier || deviceId.uuid)) || ''
    };
    this.localStorage.set('deviceInfo', deviceInfo).then(res => {
    });
    await this.storage.create();
    // Gọi SAU create(): AuthTokenService phải đọc được LMS_CREDENTIAL trong
    // Ionic Storage. Gọi sớm hơn (trong platform.ready) thì có lúc storage chưa
    // sẵn sàng, đọc ra rỗng và việc lấy token âm thầm hỏng ngay lần mở app đầu.
    this.migrateAccessToken();
    if (this.platform.is('ios') || this.platform.is('android')) {

      const platforms = this.platform.platforms().join(',');
      //     // If using a custom driver:
      // await this.storage.defineDriver(MyCustomDriver)
      // Request permission to use push notifications
      // iOS will prompt user and return if they granted permission or not
      // Android will just grant without prompting
      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          // console.log('granted', this.platform.platforms());
          PushNotifications.register().then(en => {
            // console.log('PushNotifications.register()');
          });
        } else {
          // Show some error
        }
      });

      PushNotifications.addListener('registration', (token: Token) => {
        /*console.log('token', token.value);
        alert('Push registration success, token: ' + token.value);
        console.log('mSchool token:', token.value);*/
        this.localStorage.set('fcmToken', token.value).then(res => {
          // alert('saved token success: ' + token.value);
          console.log('saved token success');
        });
      });

      PushNotifications.addListener('registrationError', (error: any) => {
        console.log('Error on registration: ' + JSON.stringify(error));
      });
      PushNotifications.addListener(
        'pushNotificationReceived',
        (notification: PushNotificationSchema) => {
          // alert('Push received: ' + JSON.stringify(notification));
        },
      );

      PushNotifications.addListener(
        'pushNotificationActionPerformed',
        (notification: ActionPerformed) => {
          //alert('Push action performed: ' + JSON.stringify(notification)); //JSON.stringify(notification));
          console.log('pushNotificationActionPerformed', JSON.stringify(notification));
          console.log('notification', notification.notification.data);
          console.log('tap', notification.actionId);
          //
          let notiType = +notification.notification.data['gcm.notification.messageType'];
          if (!notiType) {
            notiType = +notification.notification.data.messageType;
          }
          /*
          Message = 0,
          Announcement = 1,
          Score = 2,
          Feedback = 3,
          Attendent = 4,
          Review = 5,
          Polling = 6,
          RequestPermission = 7*/
          if (notiType === Constant.NOTIFICATION_TYPE_SMS || notiType === Constant.NOTIFICATION_TYPE_MEDIA) {
            let messageId = notification.notification.data['gcm.notification.messageId'];
            if (!messageId) {
              messageId = notification.notification.data.messageId;
            }
            this.router.navigateByUrl(`/student-message/${messageId}/${notiType}`);
          } else if (notiType === Constant.NOTIFICATION_TYPE_CONVERSATION) {
            this.router.navigate(['/main/tab4']);
          } else if (notiType === Constant.NOTIFICATION_TYPE_POLLING) {
            this.router.navigate(['/student-polling']);
          } else if (notiType === Constant.NOTIFICATION_TYPE_HOMEWORK) {
            this.router.navigate(['/student-homework']);
          } else if (notiType === Constant.NOTIFICATION_TYPE_REQUEST_PERMISSION) {
            this.router.navigate(['/teacher-absence-approve']);
          }
        },
      );
    }


  }

  /**
   * Lấy accessToken cho những máy đã đăng nhập từ trước.
   *
   * Token chỉ được lưu ở màn đăng nhập, mà người dùng cũ không đi qua màn đó nữa
   * (login.page.ts thấy còn selected_student là vào thẳng tab1). Không có bước này
   * thì sau khi cập nhật app, mọi phụ huynh hiện tại đều không có token và chức
   * năng Học bạ điện tử báo "hết phiên đăng nhập" với tất cả mọi người.
   *
   * Chạy ngầm, không chặn khởi động, không hiện gì cho người dùng. Thất bại cũng
   * không sao: các API khác vẫn chạy không cần token, riêng màn học bạ sẽ thử lại
   * một lần nữa rồi mới báo người dùng đăng nhập lại.
   */
  private migrateAccessToken() {
    // Chưa có token -> lấy lần đầu (người đang cài app cũ, chưa qua màn đăng nhập).
    // Đã có token -> gia hạn nếu gần hết hạn, để người dùng không bao giờ phải
    // đăng nhập lại chỉ vì token hết hạn.
    //
    // Cả hai đều im lặng: đây là việc nền, hỏng thì màn Học bạ tự xử lý sau.
    if (!this.authToken.token) {
      this.authToken.ensureToken().catch(() => {
      });
      return;
    }
    this.authToken.giaHanNeuGanHan().catch(() => {
    });
  }
}
